var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    bold: _vm.formats.includes('bold'),
    italic: _vm.formats.includes('italic'),
    heading: _vm.formats.includes('heading'),
    deleted: _vm.formats.includes('deleted'),
  }},[(_vm.data.format === 'url')?[_c('a',{attrs:{"href":_vm.data.href}},[_vm._t("default")],2)]:(_vm.data.format === 'internal-url')?[_c('router-link',{attrs:{"to":{ name: _vm.data.name }}},[_vm._t("default")],2)]:[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }